import axios from "axios";
import API_URL from "./apiConfig";

import { store } from "../redux/store"; // Importa el store de Redux
import { logout } from "../redux/authSlice"; // Importa la acción de logout
import { toast } from "react-toastify";

const { origin } = new URL(API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const rawApi = axios.create({
  baseURL: origin, // e.g. http://localhost:5001
  headers: { "Content-Type": "application/json" },
});

// Agregar token a todas las peticiones
api.interceptors.request.use((config) => {
  console.log("📤 [AXIOS] Petición enviada:", {
    url: config.url,
    method: config.method.toUpperCase(),
    headers: config.headers,
    data: config.data || "Sin datos",
    params: config.params || "Sin parámetros",
  });

  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    const { success = true, mensaje = "Operación exitosa", data } = response.data;

    console.log("📥 [AXIOS] Respuesta recibida:", {
      url: response.config.url,
      status: response.status,
      success,
      mensaje,
      data,
    });

    return {
      success,
      mensaje,
      data,
    };
  },

  (error) => {
    const status = error.response?.status || 500;
    const mensaje = error.response?.data?.mensaje || "Ocurrió un error inesperado";
    const errorData = error.response?.data?.error || error.message;

    console.error("❌ [AXIOS] Error en respuesta:", {
      url: error.config?.url,
      status,
      mensaje,
      error: errorData,
    });

    if (status === 401 && window.location.pathname !== "/login") {
      console.warn("⚠️ Sesión expirada. Redirigiendo al login...");
      toast.error("Tu sesión ha expirado. Por favor inicia sesión nuevamente.");

      store.dispatch(logout());
      window.location.href = "/login";
    }

    return Promise.reject({
      status,
      mensaje,
      error: errorData,
    });
  }
);

export default api;
export { rawApi };
